import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('searchbar', '.header__search');
loader('megamenu', '.megamenu');
loader('menu', '.menu');
loader('sticky', '.header');
loader('navbar', '.header');
loader('filter', '.filter');
loader('cart', '.cart-page');
loader('instantSearch', '.product-archive');
loader('checkout', '.checkout-page');
loader('facetFilter', '.archive-product-aside__facet');
loader('lightbox', '.single-product');
loader('tabs', '.tabs');
loader('foldout', '.foldout');
loader('faqs', '.faq');
loader('product', '.single-product');
loader('popup', '.popup');
loader('share-product', '.share-product');
loader('shopfoldout', '.shop-foldout');
loader('product-slider', '.single-product__gallery-images');
loader('product-archive', '.product-archive');
loader('clipboardCopy', '.button-clipboard');
loader('languageSwitcher', '.language-switcher');
loader('checkbox', '.checkbox');
